import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { Box, Container, Grid, Typography } from "@mui/material";

import Products from "./Products";
import SingleProductPage from "./SingleProductPage";
import Home from "./Home";
import Nav from "./Nav";

function Routing() {
  const [selectedCategory, setSelectedCategory] = useState(
    "table-linen-overlays"
  );
  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <Box className="header">
        <Container maxWidth="lg">
          <Typography>
            Welcome to Fine Linen Rental Service. Select a category to start!
          </Typography>
          <Nav onSelectCategory={handleCategorySelect} />
        </Container>
      </Box>
      <Routes>
        <Route
          path="/"
          element={<Home setSelectedCategory={setSelectedCategory} selectedCategory={selectedCategory} />}
        />
        <Route
          path="/products/:productId"
          element={<SingleProductPage />}
        />
      </Routes>
    </>
  );
}

export default Routing;
